import { useEffect, useRef } from 'react';

export const usePrevious: any = (value: any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};